<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :name="save_to"/>
      <ul>
        <li
          v-for="(blank, i) in new Array(this.numberOfItem)"
          :key="i"
          @click="val = i+1"
          :class="[getColor(i+1), {active: val == i+1}]"
        >{{i+1}}</li>
      </ul>
      <div class="hints" v-if="hint0 || hint10">
        <div class="hint0" v-if="hint0">0 - {{hint0}}</div>
        <div class="hint0" v-else></div>
        <div class="hint10" v-if="hint10">{{this.numberOfItem}} - {{hint10}}</div>
      </div>
      <input type="text" v-model="val" style="display:none" v-validate="rules">
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="error" v-show="errors.has(label)">{{ errors.first(label) }}</span>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask';
import { validatorComponent } from './validatorComponentMixin';
import { customBlurMixin } from './customBlurMixin';

export default {
  name: 'CustomerExpMetric',
  components: { MaskedInput },
  mixins: [validatorComponent, customBlurMixin],
  props: {
    save_to: String,
    placeholder: String,
    required: Boolean,
    unique: Boolean,
    validationLabel: String,
    _id : String,
    numberOfItem: Number,
    numberOfRedItem: Number,
    numberOfGreenItem: Number,
    hint10: String,
    hint0: String,
  },
  data: function () {
    return {
      rules: {
        required: this.required,
      }
    };
  },
  methods: {
    getColor(i) {
      if(this.numberOfItem - i <  this.numberOfGreenItem) {
        return "cem_green";
      } else if(i <= this.numberOfRedItem) {
        return "cem_red";
      } else {
        return "cem_yellow";
      }
    },
    getUniqueStatus() {
      if(this.unique) {
         return [this.save_to, this.operationId]
      } else {
          return false
      }
    },
    mask: function (rawValue) {
      return [/[1-2]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
    }
  }
};
</script>
<style scoped>
  ul {
    display:flex;
    list-style-type:none;
    width:100%;
    justify-content: space-between;  
    padding-left: 0;
    margin-block-end: 5px;
  }
  li {
      background:#DAE3EC;
      color:#1F324F;
      width:50px;
      height:50px;
      display:flex;
      justify-content:center;
      align-items:center;
      border-radius:100%;
      cursor:pointer;
  }
  li:focus {
      outline:none;
  }
  li.cem_green:hover, li.cem_green.active {
    background-color:#66C10A;
  }
  li.cem_yellow:hover, li.cem_yellow.active {
    background-color:#FFC416;
  }
  li.cem_red:hover, li.cem_red.active {
    background-color:#F54761;
  }
  .hints {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
</style>